/* eslint-disable react/prop-types */
import React, { useState } from 'react'
import styled, { css } from 'styled-components'
import { FaCaretDown } from 'react-icons/fa'

// import { SPACING as constants } from '../../constants'
import Typography from '../../lib/typography'
import left_arrow from '../../static/images/left-arrow.svg'

const deltaValue = ({ value }) => {
  const n = parseFloat(value)

  if (Number.isNaN(n)) return '-'
  if (n > 0) return `+${n.toString()}%`
  return `${n.toString()}%` // n<0
}

// prettier-ignore
const deltaStyles = ({ value }) => {
  const n = parseFloat(value)
  const baseStyles = css``

  if (Number.isNaN(n)) return baseStyles
  if (n < 0) return css`color: #d44b49;`
  if (n > 0) return css`color: #5cb85c;`

  return baseStyles
}

// prettier-ignore
const FAStyles = ({ delta }) => {
  if (Number.isNaN(delta)) return css``
  if (delta > 0) return css`color: #5cb85c;`
  if (delta < 0) return css`color: #d44b49;`
}

// prettier-ignore
const IconStyles = ({ value }) => {
  if (Number.isNaN(value) || value === 0) return css`display: none;`
  if (value > 0) return css`transform: rotate(180deg);`
  if (value < 0) return css`transform: rotate(0deg);`
}

const Layout = {
  Root: styled.div`
    --padding-top: 12px;

    width: auto;
    padding: calc(50px + var(--padding-top)) 16px 0;

    padding-top: 50px;
    position: relative;

    background-color: #fff;
    box-shadow: 0 3px 6px rgba(0, 0, 0, 0.16);
  `,
  Header: styled.div`
    width: 100%;
    height: 50px;
    border: 1px solid #EAEAEA;
    background: #404040;
    cursor: pointer;
    padding-left: 32px;

    display: flex;
    align-items: center;

    position: absolute;
    top: 0;
    left: 0;

    font-family: 'Gotham-Medium';
    font-size: 15px;
    color: #FFFFFF;
  `,
  Wrapper: styled.div`
    height: 70px;
    display: flex;
    align-items: center;
  `,
  Grid: styled.div`
    display: grid;
    grid-template-columns: 1fr 1fr;
  `,
  Container: styled.div`
    width: 100%;
    display: grid;
    grid-template-columns: repeat(4, 1fr);
    row-gap: 16px;
    column-gap: 40px;
  `,
  Row: styled.div`
    display: flex;
    justify-content: space-between;
    padding-bottom: 4px;
  `,
  Col: styled.div`
    display: flex;
    flex-direction: column;
  `,
  Icon: styled(FaCaretDown)`
    font-size: 16px;
    margin-right: 8px;
    ${deltaStyles}
    ${IconStyles}
  `,
  Data: styled.div`
    position: relative;

    > ${Typography.Caption} {
      color: #333333;
    }
  `,
  Delta: styled.div`
    position: absolute;
    top: 13px;
    left: 140px;

    line-height: 8px;
  `,
  DeltaText: styled(Typography.Display4)`
    &::before {
      content: '${deltaValue}';
      ${deltaStyles}
    }
  `,
  ForecastActual: styled(Typography.Display4)`
    ${FAStyles}
  `,
  Title: styled.div`
    margin-bottom: 4px;

    grid-column: span 2;

    color: #333;
    font-family: 'Gotham-Bold';
    font-size: 14px;
    line-height: 16px;
  `,
  Label: styled.div`
    font-family: 'Gotham';
    font-size: 14px;
    line-height: 16px;
    color: #808080;
  `,
  Value: styled.div`
    color: #333;
    font-family: 'Notosans';
    font-weight: 800;
    font-size: 16px;
    line-height: 18px;
    padding-top: 4px;
  `,
  ValueAmount: styled.div`
    color: #333;
    font-family: 'Notosans';
    font-weight: 800;
    font-size: 12px;
    line-height: 18px;
    padding-top: 4px;
  `,
  ForecastValue: styled.div`
    color: #333;
    font-family: 'Notosans';
    font-weight: 800;
    font-size: 16px;
    line-height: 18px;
    padding-top: 4px;
    ${FAStyles}
  `,
  ForecastValueAmount: styled.div`
    color: #333;
    font-family: 'Notosans';
    font-weight: 800;
    font-size: 12px;
    line-height: 18px;
    padding-top: 4px;
    ${FAStyles}
  `,
  Divider: styled.div`
    border-left: 1px dashed #CCCCCC;
  `,
  Arrow: styled.img`
    width : 10px;
    height : 10px;
    position: absolute;
    top: 18px;
    left: 0;
    margin: auto 14px;
    cursor: pointer;
  `,
}

/**
 * @param {object} props
 * @param {string} props.overallInitial
 * @param {string} props.overallForecastActual
 * @param {string} props.overallFormPreviousMonth
 * @param {string} props.serviceOrigin
 * @param {string} props.serviceOriginValue
 * @param {string} props.serviceInitial
 * @param {string} props.serviceInitialValue
 * @param {string} props.serviceForecastActual
 * @param {string} props.serviceForecastActualValue
 * @param {string} props.serviceFormPreviousMonth
 */
function GrossProfits(props) {
  const [expand, setExpand] = useState(true)

  const serviceDelta = props.serviceForecastActual - props.serviceInitial
  return (
    <Layout.Root>
      <Layout.Header onClick={ () => setExpand(!expand) }>
        Overall Gross Profit
      </Layout.Header>
      <Layout.Arrow
        style={ {
          transform: expand ? 'rotate(270deg)' : 'rotate(180deg)',
        } }
        src={ left_arrow }
        collapse={ !expand }
        onClick={ () => setExpand(!expand) }
      />
      { expand &&
      <Layout.Wrapper>
        <Layout.Grid>
          <Layout.Container>
            <Layout.Col>
              <Layout.Label>Original Approved</Layout.Label>
              <Layout.ValueAmount>({props.serviceOriginValue || '-'})</Layout.ValueAmount>
              <Layout.Value>{props.serviceOrigin || '-'}%</Layout.Value>
            </Layout.Col>
            <Layout.Col>
              <Layout.Label>Latest Approved</Layout.Label>
              <Layout.ValueAmount>({props.serviceInitialValue || '-'})</Layout.ValueAmount>
              <Layout.Value>{props.serviceInitial || '-'}%</Layout.Value>
            </Layout.Col>
            <Layout.Row>
              <Layout.Col>
                <Layout.Label>Forecast</Layout.Label>
                <Layout.ForecastValueAmount delta={ serviceDelta }>
                  ({props.serviceForecastActualValue || '-'})
                </Layout.ForecastValueAmount>
                <Layout.ForecastValue delta={ serviceDelta }>
                  {props.serviceForecastActual || '-'}%
                </Layout.ForecastValue>
              </Layout.Col>
              <Layout.Divider />
            </Layout.Row>
            <Layout.Col>
              <Layout.Row>
                <Layout.DeltaText small value={ props.serviceFormPreviousMonth } />
              </Layout.Row>
              <Layout.Label>from previous month</Layout.Label>
            </Layout.Col>
          </Layout.Container>
        </Layout.Grid>
      </Layout.Wrapper>
      }
      {/* <Layout.Container>
        <Typography.Data>Service Gross Profit (Other Cost Included)</Typography.Data>
        <Layout.Data style={ { marginTop: '16px' } }>
          <Typography.Caption>Approved Plan</Typography.Caption>
          <br />
          <Typography.Display4>{props.serviceInitial || '-'}%</Typography.Display4>
        </Layout.Data>
        <Layout.Data style={ { marginTop: 12 } }>
          <Typography.Caption>Forecast</Typography.Caption>
          <br />
          <Layout.ForecastActual delta={ serviceDelta }>
            {props.serviceForecastActual || '-'}%
          </Layout.ForecastActual>
          <Layout.Delta>
            <Layout.DeltaText small value={ props.serviceFormPreviousMonth } />
            <br />
            <Typography.Caption>from previous month</Typography.Caption>
          </Layout.Delta>
        </Layout.Data>
      </Layout.Container> */}
    </Layout.Root>
  )
}

export default GrossProfits



// WEBPACK FOOTER //
// ./src/components/project-profit-sheet/GrossProfits.jsx